var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToncoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C17.2589 21.5 21.5 17.2589 21.5 12C21.5 6.74107 17.2589 2.5 12 2.5C6.74107 2.5 2.5 6.74107 2.5 12C2.5 17.2589 6.74107 21.5 12 21.5Z",
    fill: "#0098EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2556 7.79517H8.74505C7.55824 7.79517 6.81224 9.08371 7.38869 10.1349L11.39 17.0862C11.6612 17.527 12.3055 17.527 12.5768 17.0862L16.578 10.1349C17.1884 9.08371 16.4424 7.79517 15.2556 7.79517ZM11.4239 14.9839L10.5422 13.2884L8.43987 9.52452C8.30424 9.28716 8.47378 8.98198 8.77896 8.98198H11.4239V14.9839ZM15.5608 9.52452L13.4584 13.2884L12.5768 14.9839V8.98198H15.2217C15.5268 8.98198 15.6964 9.28716 15.5608 9.52452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToncoin);
export default __webpack_public_path__ + "static/media/toncoin.0383dc892631bc1efe1d8f43f926dc0e.svg";
export { ForwardRef as ReactComponent };